import { render, staticRenderFns } from "./ScoringTile.vue?vue&type=template&id=b861d4ca"
import script from "./ScoringTile.vue?vue&type=script&lang=ts"
export * from "./ScoringTile.vue?vue&type=script&lang=ts"
import style0 from "./ScoringTile.vue?vue&type=style&index=0&id=b861d4ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0_supports-color@8.1.1___css-loader@_76e192b5d54d57fa300c67df0b5a2492/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports